import React, { useRef, useEffect } from "react";
import dynamic from 'next/dynamic';
import Head from 'next/head'
import styles from '../../styles/Home.module.css'

import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import Layout from '../../../components/layout';

const FaceMeshComponent = dynamic(() => import('../../../components/facemesh'), {
    ssr: false
  });
  
// export async function getServerSideProps({ query }) {
//   
//   let faceShape = null;
//   let eyeShapeTemp = ["Almond"];
//   if (query.faceShape) {
//     faceShape = Array.isArray(query.faceShape) ? query.faceShape : [query.faceShape];
//   }
//   return {
//     props: {
//       // page: query.page || null,
//       faceShape: faceShape,
//       eyeShape: eyeShapeTemp
//     },
//   };
// }

export default function HomePage({ faceShape, eyeShape }) {
return (
  <>
    <Head>
      <title>Nose Contour Overlay Filter | AI Makeup Recommendations</title>
      <meta
        name="description"
        content="Use our nose contour makeup guides tailored to your nose shape to understand the principles of nose contour. We use AR to overlay makeup contour guides on your face in real-time, and AI to identify your face shape."
        key="desc"
      />
    </Head>      
    {/* <main className={styles.main}>
    <Navbar />
    <FaceMeshComponent page={"makeup_recommendations/nose_contour"}/>     
    <Footer />
    </main> */}
    <Layout page={"makeup_recommendations/nose_contour"} selectedOption={"makeup_recommendations/nose_contour"}/>
  </>
  )
}

// export default HomePage;